import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["valueLabels", "placeHolder", "isVisible", "className"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import cx from 'classnames';

// Constants
import { EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';

// Components
import Ellipsis from '../../../../atoms/Ellipsis';
import FontIcon, { SIZES } from '../../../../atoms/FontIcon';

// Helpers
import { getSelectedValuesText } from './selectedValues.helpers';

// Styles
import s from './selectedValues.module.scss';
var SelectedValues = /*#__PURE__*/function (_PureComponent) {
  _inherits(SelectedValues, _PureComponent);
  var _super = _createSuper(SelectedValues);
  function SelectedValues() {
    _classCallCheck(this, SelectedValues);
    return _super.apply(this, arguments);
  }
  _createClass(SelectedValues, [{
    key: "renderPlaceholder",
    value: function renderPlaceholder() {
      var placeHolder = this.props.placeHolder;
      return /*#__PURE__*/React.createElement("div", {
        className: s.placeholder
      }, placeHolder);
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var valueLabels = this.props.valueLabels;
      var selectedText = getSelectedValuesText(valueLabels);
      return /*#__PURE__*/React.createElement(Ellipsis, {
        lines: 1
      }, selectedText);
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var isVisible = this.props.isVisible;
      var iconName = 'icon-chevron-down';
      return /*#__PURE__*/React.createElement(FontIcon, {
        size: SIZES.S,
        className: cx(s.dropdownIndicator, _defineProperty({}, s.dropdownIndicator__visible, isVisible))
      }, iconName);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        valueLabels = _this$props.valueLabels,
        placeHolder = _this$props.placeHolder,
        isVisible = _this$props.isVisible,
        className = _this$props.className,
        restProps = _objectWithoutProperties(_this$props, _excluded);
      var selectedValuePresent = !_isEmpty(valueLabels);
      return /*#__PURE__*/React.createElement("div", _extends({}, restProps, {
        className: cx(s.container, className, _defineProperty({}, s.container__visible, isVisible))
      }), selectedValuePresent ? this.renderContent() : this.renderPlaceholder(), this.renderDropdownIndicator());
    }
  }]);
  return SelectedValues;
}(PureComponent);
SelectedValues.propTypes = {
  valueLabels: PropTypes.array,
  placeHolder: PropTypes.string,
  isVisible: PropTypes.bool,
  className: PropTypes.string
};
SelectedValues.defaultProps = {
  valueLabels: EMPTY_ARRAY,
  placeHolder: __('Select...'),
  isVisible: false,
  className: ''
};
export default SelectedValues;